module.exports = __webpack_public_path__ + "img/group-indicator-icon.e96f748c.svg";